// extracted by mini-css-extract-plugin
export default {"userResult":"HdjT0","resultDetails":"J_qu9","userMiniDetails":"L0CH9","avatar":"I3jpf","close":"r4JdE"};